/**
 * Fiskal Cloud Online Registration (Kassenmeldung) API
 * ## Important notes The API description below offers an initial preview of what the service will look like.  Please be aware that there may still be breaking changes to the API.  When we mention *ELSTER* in our documentation we refer to ELSTER® (**EL**ektronische **ST**euer**ER**klärung).  ## Getting an authentication token  To be able to work with the API you need to get an authentication token to use with all subsequent API calls described below. Get the token via the [Oauth endpoint](https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token) of the Fiskal Cloud. Use client_id=df-api and grant_type=password for requesting a token. > The access token grants same access rights as the user has in the Fiskal Cloud Portal.  Example request to get token via curl: ``` curl -X POST \\ https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token \\ -H \'Accept: application/json\' \\ -H \'Content-Type: application/x-www-form-urlencoded\' \\ -d \'username=<USER_EMAILADDRESS>&password=<USER_PASSWORD>&client_id=df-api&grant_type=password\' ``` Save the access_token entry of the response and pass it as bearer token in all subsequent API calls. Pass it as header parameter. ```\'Authorization: Bearer <ACCESS_TOKEN_FROM_AUTHENTICATION>\'```  For details on access tokens, please check general Oauth documentation like [Oauth.com](https://www.oauth.com/oauth2-servers/access-tokens/access-token-response/)  ## Tenant context All methods of this API work in the context of the logged in user\'s tenant account. For creating new elements you need to set the tenant id in the request. You can retrieve your tenant id by using the /tenants/tenant endpoint. It is fixed, so it can safely stored for later use.  ## Managed Tenant You can use a different tenant for operations if you have a permission to managed them. You can select managed tenant by sending `X-Managed-Tenant` header with `tenantId` of the managed tenant. All operations (creating, updating and getting) are done in the context of the managed tenant with this header.  ``` curl -X GET \\ -i \'https://fiskal.cloud/api/eric/business-premises/{businessPremisesId}/registration-protocols/pdf\' \\ -H \'Authorization: Bearer {{AccessToken}}\' \\ -H \'X-Managed-Tenant: {{managedTenantId}}\' ``` 
 *
 * The version of the OpenAPI document: 0.1.0-preview
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { FormTypeEnumDTO } from '../model/form-type-enum-dto';
// @ts-ignore
import { RegistrationProtocolBodyDTO } from '../model/registration-protocol-body-dto';
// @ts-ignore
import { RegistrationProtocolDTO } from '../model/registration-protocol-dto';
// @ts-ignore
import { RegistrationProtocolResponseDTO } from '../model/registration-protocol-response-dto';
// @ts-ignore
import { RegistrationProtocolStatusEnumDTO } from '../model/registration-protocol-status-enum-dto';
// @ts-ignore
import { RegistrationProtocolStatusUpdateDTO } from '../model/registration-protocol-status-update-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    RegistrationProtocolsApiClientInterface,
    CreateRegistrationProtocolRequestParams,
    DownloadFormSubmissionPdfRequestParams,
    GetBusinessPremisesRegistrationProtocolsRequestParams,
    GetRegistrationProtocolRequestParams,
    GetRegistrationProtocolsRequestParams,
    UpdateRegistrationProtocolStatusRequestParams
} from './registration-protocols-api-client.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class RegistrationProtocolsApiClient implements RegistrationProtocolsApiClientInterface {

    protected basePath = 'https://fiskal.cloud/api/eric';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Trigger registration protocol submission to Elster
     * Manually trigger registration protocol submission to Elster. Available submission types:   * Abgabenordnung (AO) §146a 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRegistrationProtocol(requestParameters: CreateRegistrationProtocolRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegistrationProtocolDTO>;
    public createRegistrationProtocol(requestParameters: CreateRegistrationProtocolRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegistrationProtocolDTO>>;
    public createRegistrationProtocol(requestParameters: CreateRegistrationProtocolRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegistrationProtocolDTO>>;
    public createRegistrationProtocol(requestParameters: CreateRegistrationProtocolRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const businessPremisesId = requestParameters.businessPremisesId;
        if (businessPremisesId === null || businessPremisesId === undefined) {
            throw new Error('Required parameter businessPremisesId was null or undefined when calling createRegistrationProtocol.');
        }
        const registrationProtocolBodyDTO = requestParameters.registrationProtocolBodyDTO;
        if (registrationProtocolBodyDTO === null || registrationProtocolBodyDTO === undefined) {
            throw new Error('Required parameter registrationProtocolBodyDTO was null or undefined when calling createRegistrationProtocol.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/business-premises/${this.configuration.encodeParam({name: "businessPremisesId", value: businessPremisesId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/registration-protocols`;
        return this.httpClient.request<RegistrationProtocolDTO>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: registrationProtocolBodyDTO,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the generated PDF response file for the business premises from Elster.
     * Download the generated PDF response file. The endpoint returns two types of PDF file:   1. Preview - PDF file with watermark. It is not submission report. Only for checking whether the submission report contains the correct data.   2. Submission - Form submission. Must be downloaded before registration protocol acknowledgement.  The PDF type is downloaded based on the current registration protocol status. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadFormSubmissionPdf(requestParameters: DownloadFormSubmissionPdfRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf', context?: HttpContext}): Observable<Blob>;
    public downloadFormSubmissionPdf(requestParameters: DownloadFormSubmissionPdfRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public downloadFormSubmissionPdf(requestParameters: DownloadFormSubmissionPdfRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public downloadFormSubmissionPdf(requestParameters: DownloadFormSubmissionPdfRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf', context?: HttpContext}): Observable<any> {
        const registrationProtocolId = requestParameters.registrationProtocolId;
        if (registrationProtocolId === null || registrationProtocolId === undefined) {
            throw new Error('Required parameter registrationProtocolId was null or undefined when calling downloadFormSubmissionPdf.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let localVarPath = `/registration-protocols/${this.configuration.encodeParam({name: "registrationProtocolId", value: registrationProtocolId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/pdf`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of registration protocols from Elster for the business premises.
     * Get list of registration protocols created during form submission for the business premises. If no form type is specified, form type \&#39;AO146a\&#39; is used as default. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBusinessPremisesRegistrationProtocols(requestParameters: GetBusinessPremisesRegistrationProtocolsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegistrationProtocolResponseDTO>;
    public getBusinessPremisesRegistrationProtocols(requestParameters: GetBusinessPremisesRegistrationProtocolsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegistrationProtocolResponseDTO>>;
    public getBusinessPremisesRegistrationProtocols(requestParameters: GetBusinessPremisesRegistrationProtocolsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegistrationProtocolResponseDTO>>;
    public getBusinessPremisesRegistrationProtocols(requestParameters: GetBusinessPremisesRegistrationProtocolsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const businessPremisesId = requestParameters.businessPremisesId;
        if (businessPremisesId === null || businessPremisesId === undefined) {
            throw new Error('Required parameter businessPremisesId was null or undefined when calling getBusinessPremisesRegistrationProtocols.');
        }
        const status = requestParameters.status;
        const isDownloaded = requestParameters.isDownloaded;
        const pageNumber = requestParameters.pageNumber;
        const pageSize = requestParameters.pageSize;
        const sort = requestParameters.sort;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (status) {
            status.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status');
            })
        }
        if (isDownloaded !== undefined && isDownloaded !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isDownloaded, 'isDownloaded');
        }
        if (pageNumber !== undefined && pageNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNumber, 'pageNumber');
        }
        if (pageSize !== undefined && pageSize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageSize, 'pageSize');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/business-premises/${this.configuration.encodeParam({name: "businessPremisesId", value: businessPremisesId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/registration-protocols`;
        return this.httpClient.request<RegistrationProtocolResponseDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get registration protocol for the business premises from Elster.
     * Get registration protocol created during form submission for the business premises. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRegistrationProtocol(requestParameters: GetRegistrationProtocolRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegistrationProtocolDTO>;
    public getRegistrationProtocol(requestParameters: GetRegistrationProtocolRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegistrationProtocolDTO>>;
    public getRegistrationProtocol(requestParameters: GetRegistrationProtocolRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegistrationProtocolDTO>>;
    public getRegistrationProtocol(requestParameters: GetRegistrationProtocolRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const registrationProtocolId = requestParameters.registrationProtocolId;
        if (registrationProtocolId === null || registrationProtocolId === undefined) {
            throw new Error('Required parameter registrationProtocolId was null or undefined when calling getRegistrationProtocol.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/registration-protocols/${this.configuration.encodeParam({name: "registrationProtocolId", value: registrationProtocolId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RegistrationProtocolDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of registration protocols from Elster for the tenant.
     * Get list of registration protocols created during form submission for the business premises. If no form type is specified, form type \&#39;AO146a\&#39; is used as default. 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRegistrationProtocols(requestParameters: GetRegistrationProtocolsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegistrationProtocolResponseDTO>;
    public getRegistrationProtocols(requestParameters: GetRegistrationProtocolsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegistrationProtocolResponseDTO>>;
    public getRegistrationProtocols(requestParameters: GetRegistrationProtocolsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegistrationProtocolResponseDTO>>;
    public getRegistrationProtocols(requestParameters: GetRegistrationProtocolsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const businessPremisesIds = requestParameters.businessPremisesIds;
        const organizationIds = requestParameters.organizationIds;
        const formType = requestParameters.formType;
        const status = requestParameters.status;
        const isDownloaded = requestParameters.isDownloaded;
        const pageNumber = requestParameters.pageNumber;
        const pageSize = requestParameters.pageSize;
        const sort = requestParameters.sort;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (businessPremisesIds) {
            businessPremisesIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'businessPremisesIds');
            })
        }
        if (organizationIds) {
            organizationIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'organizationIds');
            })
        }
        if (formType !== undefined && formType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>formType, 'formType');
        }
        if (status) {
            status.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status');
            })
        }
        if (isDownloaded !== undefined && isDownloaded !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isDownloaded, 'isDownloaded');
        }
        if (pageNumber !== undefined && pageNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNumber, 'pageNumber');
        }
        if (pageSize !== undefined && pageSize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageSize, 'pageSize');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/registration-protocols`;
        return this.httpClient.request<RegistrationProtocolResponseDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Confirm or acknowledge registration protocol for the business premises for Elster.
     * Confirm or acknowledge registration protocol created during form submission for the business premises.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRegistrationProtocolStatus(requestParameters: UpdateRegistrationProtocolStatusRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegistrationProtocolDTO>;
    public updateRegistrationProtocolStatus(requestParameters: UpdateRegistrationProtocolStatusRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegistrationProtocolDTO>>;
    public updateRegistrationProtocolStatus(requestParameters: UpdateRegistrationProtocolStatusRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegistrationProtocolDTO>>;
    public updateRegistrationProtocolStatus(requestParameters: UpdateRegistrationProtocolStatusRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const registrationProtocolId = requestParameters.registrationProtocolId;
        if (registrationProtocolId === null || registrationProtocolId === undefined) {
            throw new Error('Required parameter registrationProtocolId was null or undefined when calling updateRegistrationProtocolStatus.');
        }
        const ifMatch = requestParameters.ifMatch;
        if (ifMatch === null || ifMatch === undefined) {
            throw new Error('Required parameter ifMatch was null or undefined when calling updateRegistrationProtocolStatus.');
        }
        const registrationProtocolStatusUpdateDTO = requestParameters.registrationProtocolStatusUpdateDTO;
        if (registrationProtocolStatusUpdateDTO === null || registrationProtocolStatusUpdateDTO === undefined) {
            throw new Error('Required parameter registrationProtocolStatusUpdateDTO was null or undefined when calling updateRegistrationProtocolStatus.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (ifMatch !== undefined && ifMatch !== null) {
            localVarHeaders = localVarHeaders.set('If-Match', String(ifMatch));
        }

        let localVarCredential: string | undefined;
        // authentication (management_auth) required
        localVarCredential = this.configuration.lookupCredential('management_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/registration-protocols/${this.configuration.encodeParam({name: "registrationProtocolId", value: registrationProtocolId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/status`;
        return this.httpClient.request<RegistrationProtocolDTO>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: registrationProtocolStatusUpdateDTO,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
